import { render, staticRenderFns } from "./BuyCreate.vue?vue&type=template&id=c1b619ba&scoped=true&"
import script from "./BuyCreate.vue?vue&type=script&lang=js&"
export * from "./BuyCreate.vue?vue&type=script&lang=js&"
import style0 from "./BuyCreate.vue?vue&type=style&index=0&id=c1b619ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b619ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VSelect,VTextField,VTextarea})
